var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19437_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5023 11.8181L13.2734 1.59443L12.5877 0.908793C12.4315 0.753603 12.2203 0.666504 12 0.666504C11.7798 0.666504 11.5686 0.753603 11.4124 0.908793L0.497791 11.8181C0.337715 11.9775 0.211205 12.1674 0.125727 12.3766C0.0402491 12.5857 -0.0024636 12.8099 0.000109727 13.0358C0.0106987 13.9676 0.78634 14.7115 1.71817 14.7115H2.84325V23.3336H21.1569V14.7115H22.3058C22.7584 14.7115 23.1846 14.5341 23.505 14.2138C23.6627 14.0566 23.7876 13.8697 23.8726 13.6638C23.9576 13.458 24.0009 13.2373 24 13.0146C24 12.5646 23.8226 12.1384 23.5023 11.8181ZM13.4825 21.4276H10.5176V16.0272H13.4825V21.4276ZM19.2508 12.8055V21.4276H15.1767V15.3918C15.1767 14.8068 14.7029 14.3329 14.1178 14.3329H9.88226C9.29722 14.3329 8.82336 14.8068 8.82336 15.3918V21.4276H4.74926V12.8055H2.20791L12.0027 3.01864L12.6142 3.63016L21.7948 12.8055H19.2508Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19437_2215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/house.5bc35ae0.svg";
export { ForwardRef as ReactComponent };